module.exports = __webpack_public_path__ + "img/diageo-distillery-building-site-1.cc62893e.png";